import { action, global } from "../const";
import { getServerResponse } from "../functions";
import { reSignIn } from "./Auth";
import moment from "moment";

export function statistic_action_tab(tab) {
    return (dispatch) => dispatch({
        type: action.STATISTICS_TAB_CHANGE,
        tab
    })
}


// [#205 WcnEnglishData.getUserList] As we will show the Woogi English data belongs to a specific user, here we first list all family members for chossing before loading data of Woogi English.
export const getUserList = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;

        try {
            let response = await getServerResponse({ cmd: 'WcnEnglishData.getUserList', token: userInfo.token });

            dispatch({
                type: action.STATISTICS_USERS_LIST,
                users: response.error ? [] : response
            });
        } catch (error) {
            if (global.IS_DEBUG) console.log("WcnEnglishData.getUserList:- ", error);
            dispatch({ type: action.STATISTICS_USERS_LIST, users: [] });
        }
        return;
    }
};


// [#207 WcnEnglishData.getPreviewData] A brief overview of activites in Woogi English
export const getPreviewData = (data) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let response = await getServerResponse({ cmd: "WcnEnglishData.getPreviewData", token: userInfo.token, user_id: data.user_id });
            response = { ...response, ...data };
            console.log(response);
            dispatch({
                type: action.STATISTICS_SET_USER_INFO,
                user: response
            });
            return true
        } catch (error) {
            alert(error)
            if (global.IS_DEBUG) console.log("WcnEnglishData.getPreviewData:- ", error);
            return false
        }
    }
};


// [#206 WcnEnglishData.getUnitProgressLists] Progress on each unit.
export const getUnitProgressLists = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        return await new Promise(async (resolve) => {
            try {
                let response = await getServerResponse({ cmd: 'WcnEnglishData.getUnitProgressLists', token: userInfo.token, user_id: selected_user.user_id });
                return resolve(response);
            } catch (error) {
                if (global.IS_DEBUG) console.log("WcnEnglishData.getUnitProgressLists:- ", error);
            }
        });
    }
};

// [#208 WcnEnglishData.getUnitDetails] Progress on each lessons.
export const getUnitDetails = (unit) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        return await new Promise(async (resolve) => {
            try {
                let response = await getServerResponse({ cmd: 'WcnEnglishData.getUnitDetails', token: userInfo.token, user_id: selected_user.user_id, unit });
                return resolve(response);
            } catch (error) {
                if (global.IS_DEBUG) console.log("WcnEnglishData.getUnitDetails:- ", error);
            }
        });
    }
};

// [#209 WcnEnglishData.getOnlineLog] time progress.
export const getOnlineLog = (days) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        return await new Promise(async (resolve) => {
            try {
                dispatch({ type: action.ACTIVITIES_TIME_PROGRESS, progress: undefined });
                let response = await getServerResponse({ cmd: 'WcnEnglishData.getOnlineLog', token: userInfo.token, user_id: selected_user.user_id, days });

                if (response.error) return false;
                let totalHours = 0;

                if (days === 1) {
                    let group1 = [], group2 = [], group3 = [], group4 = [];
                    Object.keys(response).map((item) => {
                        let index = Number(item.substring(0, 2))
                        let progress = Math.round(response[item] / 60);
                        totalHours += response[item];
                        if (index <= 5) group1.push({ "time": item, "progress": progress })
                        else if (index >= 6 && index <= 11) group2.push({ "time": item, "progress": progress })
                        else if (index >= 12 && index <= 17) group3.push({ "time": item, "progress": progress })
                        else group4.push({ "time": item, "progress": progress })
                    })
                    response = [{ title: "0 AM", data: group1 }, { title: "6 AM", data: group2 }, { title: "12 AM", data: group3 }, { title: "18 AM", data: group4 }];
                } else {
                    let data = [];
                    Object.keys(response).map((item) => {
                        let progress = Math.round(Number(response[item]) / 60);
                        totalHours += Number(response[item]);
                        data.push({ title: moment(item).format("Do"), progress })
                    })
                    response = data
                }
                dispatch({
                    type: action.ACTIVITIES_TIME_PROGRESS,
                    progress: response,
                    totalProgressTime: totalHours
                });
                return resolve(response);
            } catch (error) {
                if (global.IS_DEBUG) console.warn("WcnEnglishData.getOnlineLog:- ", error);
            }
        });
    }
};


// [#210 WcnEnglishData.videoLists]
export const videoLists = () => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let response = [];
        try {
            response = await getServerResponse({ cmd: "WcnEnglishData.videoLists", token: userInfo.token });
            if (response.error) response = [];
        } catch (error) {
            if (global.IS_DEBUG) console.log("WcnEnglishData.videoLists:- ", error);
        }
        dispatch({
            type: action.ACTIVITIES_LOGS_VIDEOS,
            videos: response
        });
    }
};

// [#211 WcnEnglishData.getRecordingByDate]
export const getRecordingByDate = (date) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        let response = [];
        try {
            response = await getServerResponse({ cmd: 'WcnEnglishData.getRecordingByDate', token: userInfo.token, user_id: selected_user.user_id, date });
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getRecordingByDate:- ", error);
        }
        return response;
    }
};

// [#220 WcnEnglishData.getRecordingByPage]
export const WcnEnglishData = (page) => {
    page = page || 1
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        try {
            let response = await getServerResponse({
                cmd: "WcnEnglishData.getRecordingByPage",
                token: userInfo.token,
                user_id: selected_user.user_id,
                page,
                amount: global.LIST_AMOUNT
            });
            if(response.error) {
                console.log(response);
                return;
            }
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getRecordingByPage:- ", error);
        }
    }
}


// [#212 WcnEnglishData.getAnswerRecord]
export const getAnswerRecord = (page) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        try {
            let response = await getServerResponse({ cmd: "WcnEnglishData.getAnswerRecord", token: userInfo.token, user_id: selected_user.user_id, page, amount: global.LIST_AMOUNT });
            if (!response.error)
                dispatch({
                    type: action.ACTIVITIES_LOGS_QUESTIONS,
                    payload: response || []
                });
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getAnswerRecord:- ", error);
        }
    }
};


// [#217 WcnEnglishData.getActiveUnits]
export const getActiveUnits = (date) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        try {
            let response = await getServerResponse({ cmd: "WcnEnglishData.getActiveUnits", token: userInfo.token, user_id: selected_user.user_id, date });
            if (response.error) return;
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getActiveUnits:- ", error);
        }
        return;
    }
};

// [#216 WcnEnglishData.getLessonRecords]
export const getLessonRecords = (date, unit, lesson) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        try {
            let response = await getServerResponse({ cmd: "WcnEnglishData.getLessonRecords", token: userInfo.token, user_id: selected_user.user_id, date, unit, lesson });
            if (response.error) return;
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getLessonRecords:- ", error);
        }
        return;
    }
};

// [#221 WcnEnglishData.getDailyRecordingAmount]
export const getAudioRecordsByDate = (year, month) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        let { selected_user } = getState().statistics;
        try {
            let response = await getServerResponse({ cmd: "WcnEnglishData.getDailyRecordingAmount", token: userInfo.token, user_id: selected_user.user_id, year, month });
            if (response.error && response.error === 121) {
                reSignIn();
            } else {
                return response;
            }
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getDailyRecordingAmount:- ", error);
        }
        return []
    }
};

// [#223 WcnUser1.updateWeSwitch]
export const updateWeSwitch = (isEnable) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let request = { cmd: "WcnUser1.updateWeSwitch", token: userInfo.token }
            if (isEnable === true || isEnable === false) {
                dispatch({ type: isEnable ? action.IS_ENGLISH_ENABLE : action.IS_ENGLISH_DISABLE });
                request = { ...request, switch: isEnable ? 1 : 0 }
            }
            let response = await getServerResponse(request);
            dispatch({ type: response === 1 ? action.IS_ENGLISH_ENABLE : action.IS_ENGLISH_DISABLE });
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnUser1.updateWeSwitch:- ", error);
        }
    }
};

// [#224 WcnEnglishData.setAudioComment]
export const setAudioComment = (audio_id, grade, label, comment) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let request = { cmd: "WcnEnglishData.setAudioComment", token: userInfo.token, audio_id, grade, label, comment }
            let response = await getServerResponse(request);
            if (response.error) return undefined;
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.setAudioComment:- ", error);
        }
    }
};

// [#225 WcnEnglishData.getAudioInfo]
export const getAudioInfo = (id) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let request = { cmd: "WcnEnglishData.getAudioInfo", token: userInfo.token, id }
            let response = await getServerResponse(request);
            if (response.error) return undefined;
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getAudioInfo:- ", error);
        }
    }
};

// [#226 WcnEnglishData.getAllAudioComment]
export const getAllAudioComment = (id) => {
    return async (dispatch, getState) => {
        let { userInfo } = getState().auth;
        try {
            let request = { cmd: "WcnEnglishData.getAllAudioComment", token: userInfo.token, id }
            let response = await getServerResponse(request);
            if (response.error) return undefined;
            return response;
        } catch (error) {
            if (global.IS_DEBUG) console.warn("WcnEnglishData.getAllAudioComment:- ", error);
        }
    }
};

